module.exports = __webpack_public_path__ + "static/img/adv-banner-1-hk.1438dc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/adv-banner-1-hk.jpg
// module id = WRE/
// module chunks = 1